var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfileChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2469 9.9763C14.9636 10.493 14.4136 10.8346 13.7886 10.8346H7.58024L6.66357 12.5013H16.6636V14.168H6.66357C5.39691 14.168 4.59691 12.8096 5.20524 11.693L6.33024 9.65964L3.33024 3.33464H1.66357V1.66797H4.38857L5.17191 3.33464H17.5052C18.1386 3.33464 18.5386 4.01797 18.2302 4.56797L15.2469 9.9763ZM16.0886 5.0013H5.96357L7.93857 9.16797H13.7886L16.0886 5.0013ZM6.66357 15.0013C5.74691 15.0013 5.00524 15.7513 5.00524 16.668C5.00524 17.5846 5.74691 18.3346 6.66357 18.3346C7.58024 18.3346 8.33024 17.5846 8.33024 16.668C8.33024 15.7513 7.58024 15.0013 6.66357 15.0013ZM13.3386 16.668C13.3386 15.7513 14.0802 15.0013 14.9969 15.0013C15.9136 15.0013 16.6636 15.7513 16.6636 16.668C16.6636 17.5846 15.9136 18.3346 14.9969 18.3346C14.0802 18.3346 13.3386 17.5846 13.3386 16.668Z",
    fill: "#223A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileChart);
export default __webpack_public_path__ + "static/media/ic-profile-chart.b59ff1aa9531b0803078b039241d63ac.svg";
export { ForwardRef as ReactComponent };